<template>
    <div class="sn-table w-full">
        <vs-card v-if="panel" class="shadow-none">
            <slot name="panel"></slot>
        </vs-card>
        <vs-table
            ref="table"
            :max-items="pagination ? limitNum : dataTable.length"
            pagination
            :search="search"
            :data="dataTable"
            hoverFlat :stripe="stripe"
            :noDataText="i('table.No_data_available')"
        >
            <div slot="header" class="flex items-center w-full">
                <div>
                    <slot name="header"></slot>
                </div>
                <div class="flex justify-between w-full" v-if="pagination">
                    <div class="flex items-center justify-between">
                        <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 items-per-page-handler">
                            <div class="p-4 border border-solid flex d-theme-border-grey-light rounded-full flex-grow d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2 whitespace-no-wrap">
                                    {{ (pageNum - 1) * limitNum + 1 }} - {{ (pageNum - 1) * limitNum + limitNum }} of {{ allItems }}
                                </span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item v-for="(item, index) of itemsPagination" :key="index" @click="changeLimit(item)">
                                    <span>{{ item }}</span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>

                    <div class="flex items-center">
                        <vs-input v-if="search" icon-pack="feather" icon="icon-search" :placeholder="i('global.Search')" v-model.trim="searchInput" class="search is-label-placeholder w-full mr-4" />
                        <vs-pagination ref="pagination" :max="refPaginationPagesLength < 9 ? refPaginationPagesLength : 9" color="primary" v-model="pageNum" :total="totalRecPages" />
                    </div>
                </div>
            </div>

            <template slot="thead">
                <vs-th v-for="(head, index) of heads" v-if="head.display && isPermission(head.can)" :sort-key="head.sortKey" :key="index">
                    {{ i(head.name) }}
                </vs-th>
            </template>

            <template slot-scope="{data}" v-if="data.length">
                <tbody>
                <template v-for="(tr, ind) of data">
                    <vs-tr :key="ind">
                        <vs-td v-if="head.display && isPermission(head.can)" v-for="(head, index) of heads" :key="index">
                            <slot :name="head.value" v-bind="{[head.value]: tr}">
                                <div class="whitespace-no-wrap">{{ tr[head.value] ? tr[head.value] : '-' }}</div>
                            </slot>
                        </vs-td>

                        <template v-if="details" slot="expand">
                            <slot name="details" v-bind:details="tr"></slot>
                        </template>
                    </vs-tr>

                    <vs-tr v-if="!stripe" class="spacer" :key="ind + '-list'">
                        <vs-td :colspan="heads.length"></vs-td>
                    </vs-tr>
                </template>
                </tbody>
            </template>
        </vs-table>

        <div class="mt-4" v-if="pagination">
            <vs-pagination
                color="primary"
                v-model="pageNum"
                :total="totalRecPages"
                ref="pagination2"
                :max="refPaginationPagesLength < 9 ? refPaginationPagesLength : 9"
            />
        </div>
    </div>
</template>

<script>
import i18n from "@/i18n/i18n"
import {fixHindusPagination} from '@/utils/mixins'
export default {
    mixins: [fixHindusPagination],
    data() {
        return {
            isMounted: false,
            pageNum: 1,
            limitNum: 1,
            totalRecPages: 1,
            searchInput: '',
            refPaginationPagesLength: 0
        }
    },

    props: {
        panel: { type: Boolean, default: true },
        allItems: { type: Number, required: true },
        page: { type: Number, default: 1 },
        itemsPagination: { type: Array, required: true },
        viewLimit: { type: Number, required: true },
        heads: { type: Array, required: true },
        stripe: { type: Boolean, default: false },
        dataTable: { type: Array, required: true },
        search: { type: Boolean, default: false },
        additionallyCheckByDomains: {type: Array, default() { return [] }},
        // sst: { type: Boolean, default: false }
        details: {type: Boolean, default: false},
        pagination: {type: Boolean, default: true},
    },

    computed: {
        permission() {
            return this.$store.state.userPermissions
        },
    },

    watch: {
        page(page) {
            this.pageNum = page
        },

        searchInput(val) {
            const foundDomain = this.additionallyCheckByDomains.length ? this.additionallyCheckByDomains.find(domain => domain && domain.label === val) : null;

            if (foundDomain){
                const foundDomainInTable = this.tableData.some(data => {
                    if (data.domains){
                        return data.domains.some(el => el === foundDomain.value)
                    }
                })

                foundDomainInTable ?  this.$emit('foundDomain', foundDomain.value) :  this.$refs.table.searchx = val
            } else {
                this.$emit('foundDomain', false)
                this.$refs.table.searchx = val
            }
        },

        // dataTable(val) {
        //     if (val && Array.isArray(val)) {
        //         val.length ? this.pageNum = 1 : this.pageNum
        //     }
        // }
    },

    methods: {
        isPermission(name) {
            if (name) {
                name = name.split('.')
                if (this.permission[name[0]]) {
                    return this.permission[name[0]].includes(name[1])
                } else {
                    return false
                }
            }
            return true
        },

        changeLimit(data) {
            this.limitNum = data
            this.pageNum = 1
            this.$refs.table.currentx = this.pageNum
        },

        i(val) {
            return i18n.tc(val)
        }
    },

    mounted() {
        const divs = document.querySelectorAll('.con-vs-pagination')
        let num = this.pageNum
        for (const div of divs) {
            div.addEventListener('click', event => {
                if (num !== this.pageNum) {
                    this.$refs.table.currentx = this.pageNum
                    num = this.pageNum
                }
            })
        }

        if (this.page) {
            this.pageNum = this.page
        }

        this.limitNum = this.viewLimit

        this.$watch(
            () => {
                return this.$refs.table.getTotalPagesSearch
            },
            val => {
                this.pageNum = 1
                this.$refs.table.currentx = this.pageNum
                this.totalRecPages = val

                const tr = document.querySelectorAll('.tr-expand')
                if (tr) [...tr].map(element => element.remove())
            }
        )

        this.$watch(
            () => {
                if (this.$refs.pagination) {
                    return this.$refs.pagination.pages
                }
            },
            value => {
                if (value) {
                    this.$set(this, 'refPaginationPagesLength', value[value.length -1])

                    Object.assign(this.$refs.pagination, {getPages: this.getPages(this.$refs.pagination)})
                    Object.assign(this.$refs.pagination2, {getPages: this.getPages(this.$refs.pagination2)})
                }
            }
        )
    },
}
</script>

<style lang="scss">
.sn-table {
    .tr-expand > td {
        padding: 0 !important;
        .vs-con-tbody {
            border: none !important;
            td {
                border: none !important;
            }
        }
    }
    .vs-inputx {
        &:focus {
            border: 1px solid rgba(0, 0, 0, 0.2) !important;
            box-shadow: none !important;
        }
    }
    .con-pagination-table {
        display: none;
    }

    .search input {
        border-radius: 50px;
    }

    .vs-con-table .vs-table--header .vs-table--search {
        display: none !important;
    }

    .vs-pagination--ul {
        li {
            font-size: .8rem;
            width: 30px;
            height: 30px;
        }
    }

    .vs-card--content {
        padding: 0;
    }

    .vs-table--thead tr {
        background: none;
    }
}
</style>
